import { blogCategoryDetails as blogCategory1} from "./1";

const contentObject = {
    [blogCategory1.id]: blogCategory1,
}
export default contentObject;
